module.exports = __webpack_public_path__ + "img/mb_product_bg_small.c5858cf.webp";